import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { reducer as reduxFormReducer } from 'redux-form';
import { modals } from '@app/src/commons/modal/state/modals';
import { user as userReducer }       from '@app/src/views/Login/login/state/login';
import { userOdt as userOdtReducer } from '@app/src/views/LoginMfa/loginMfa/state/loginMfa';
import { userList as userListReducer } from '@app/src/views/Users/list/state/userList';
import { recoverPassword as recoverPasswordReducer } from '@app/src/views/Login/login/state/recoverPassword';
import { processCip as processCipReducer } from '@app/src/views/CipGeneration/generateForm/state/processCip';
import { detail as detailReducer } from '@app/src/views/CipReport/report/state/detail';
import { filterValues as filterValuesReducer } from '@app/src/views/CipReport/report/state/filterValues';
import { operator as operatorReducer } from '@app/src/views/CipReport/filter/state/operator';
import { paymentType as paymentTypeReducer } from '@app/src/views/CipReport/filter/state/paymentType';
import { validationDateRange as validationDateRangeReducer } from '@app/src/views/CipReport/filter/state/validationDateRange';
import { createUser as createUserReducer } from '@app/src/views/CreateUsers/createUSer/state/createUser';
import { filterEditUserValues as fetchUserValuesReducer } from '@app/src/views/EditUser/editUser/state/filterValues';
import { editUserValues as editUserValuesReducer } from '@app/src/views/EditUser/editUser/state/editUser';
import { createPassword as createPasswordReducer } from '@app/src/views/Login/createPassword/state/createPassword';
import { validateToken as validateTokenReducer } from '@app/src/views/Login/createPassword/state/validateToken';
const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default () => {
  const store = createStore(
    combineReducers({
      user: userReducer,
      userOdt: userOdtReducer,
      createPassword: createPasswordReducer,
      recoverPassword: recoverPasswordReducer,
      validateToken: validateTokenReducer,
      processCip: processCipReducer,
      form: reduxFormReducer,
      modals,
      detail: detailReducer,
      filterValues: filterValuesReducer,
      operator: operatorReducer,
      paymentType: paymentTypeReducer,
      validationDateRange: validationDateRangeReducer,
      userList: userListReducer,
      createUser: createUserReducer,
      filterEditUser: fetchUserValuesReducer,
      editUser: editUserValuesReducer
    }),
    (window as any).__PRELOADED_STATE__,
    composeEnhancers(applyMiddleware(thunk))
  );
  return store;
}
